import { Tooltip, tooltipClasses, Typography } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import {
    multiLineEllipsisStyles,
    useMediaQuery,
} from "@mediaspace/shared/utils";
import { useTheme, Box } from "@mediaspace/shared/styled";
import CounterContainer from "../counter/CounterContainer";
import { NoCounterText } from "../StyledComponents";
import {Truncate} from "@mediaspace/shared/ui";

export interface TitleProps {
    title: string;
    showCounter: boolean;
    startTime?: number;
    statusLabel?: string;
}

const Container = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
        justifyContent: "center",
    },
}));

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
    [`&.${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.common.white,
        color: theme.palette.common.black,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.kaltura.typography.fontWeightBold,
        padding: theme.spacing(1),
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
        bottom: 1,
    },
}));

const Text = styled(Typography)<{ variant: "h1" | "h2" | "h3" }>(
    ({ theme, variant }) => ({
        ...multiLineEllipsisStyles(4, theme.typography[variant]),
        margin: 0,
        [theme.breakpoints.down("md")]: {
            alignSelf: "center",
        }
    })
);

/**
 * title component
 * renders media's name as title
 */
const Title = (props: TitleProps) => {
    const { title, showCounter, startTime, statusLabel } = props;

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    const isXl = useMediaQuery(theme.breakpoints.up("xl"));
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Container className={"kms-ds-media-page-lobby-title"}>
            {showCounter && (
                <CounterContainer
                    startTime={startTime}
                    counterTextWhenEnds={""}
                />
            )}

            {!showCounter && statusLabel && (
                <NoCounterText variant={"body2Highlight"} className={"kms-ds-media-page-lobby-status"}>
                    {statusLabel}
                </NoCounterText>
            )}
            <StyledTooltip title={title} placement={"top"}>
                <Text
                    component="h1"
                    variant={isXl ? "h1" : isSm ? "h3" : "h2"}
                    className={"kms-ds-media-page-lobby-title-text"}
                >
                    <Truncate
                        lines={isXs ? 1 : 3}
                        showMore={false}
                    >
                        {title}
                    </Truncate>
                </Text>
            </StyledTooltip>
        </Container>
    );
};

export default Title;
